import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import KeyValueInput from '../../../../../../components/form/KeyValueInput'
import Modal from '../../../../../../components/structure/Modal'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../../../../packages/kiti/components/presentation/Text'

const WebhookSentence = () => {
  const [open, setOpen] = React.useState()
  const { t } = useTranslation('triggers')
  const { handleChangeIn, form } = useFormState()

  return (
    <>
      <Text size="h2">com url:</Text>
      <EditableSentence
        label={form.payload?.url || '_______'}
        truncate={20}
        onClick={() => setOpen(true)}
        field="payload"
      />

      <Modal open={open} onClose={() => setOpen(false)} width="32rem">
        <FormItem label="Url" path={['payload', 'url']} />

        <Separator weight={4} />

        <FormItem label="Headers" path={['payload', 'message']}>
          <KeyValueInput
            value={form.payload?.headers || [{}]}
            onChange={handleChangeIn(['payload', 'headers'])}
            keyPlaceholder={t('webhook.key')}
            valuePlaceholder={t('webhook.value')}
          />
        </FormItem>

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default WebhookSentence
